module.exports = __webpack_public_path__ + "static/media/level-one.3343b193.svg";